import React from 'react';
import { useSelector } from 'react-redux';
import {
  chartDataSelector,
  chartLoadingSelector,
} from '@store/overviewDashboard/kpiData/selectors';
import { kpiMetricSelector } from '@store/overviewDashboard/base/selectors';
import { HelpPopup } from '@components/overview-dashboard/common/help-popup';
import { IMPROVEMENT_OPPORTUNITY_METRICS } from '@src/utils/kpi';
import { getMetricMetaByKey } from '@src/utils/metrics';
import { Retry } from '@components/common';
import { KPIOrder } from './utils';
import { ContentWrapper, StyledPara, StyledParaHeader } from './styled';
import MetricCard from './MetricCard';

function Content({ helpContext, retryHandler }) {
  const chartData = useSelector(chartDataSelector);
  const selectedMetric = useSelector(kpiMetricSelector);
  const { loading, errorMsg } = useSelector(chartLoadingSelector);

  const isSelectedMetric = (metric) => metric === selectedMetric;
  const { METRIC_ARR, emptyMetrics, totalMetrics } = KPIOrder(chartData);

  const renderHelpText = () => {
    const data: any = [];
    IMPROVEMENT_OPPORTUNITY_METRICS.map((metric) => {
      const metricInfo = getMetricMetaByKey({ metricKey: metric });
      const header = `${metricInfo.ovbDisplayName} :`;
      const help = metricInfo.helpText;
      data.push(
        <>
          <StyledParaHeader>{header}</StyledParaHeader>
          <StyledPara>{help}</StyledPara>
        </>,
      );
    });
    return data;
  };

  const isError = errorMsg && errorMsg.length > 0;
  const isEmpty = totalMetrics === emptyMetrics;

  const renderPopup = () => {
    const data = renderHelpText();
    return (
      <HelpPopup
        title="Improvement Opportunities Metrics"
        helpText={data}
        helpContext={helpContext}
      />
    );
  };

  return (
    <ContentWrapper>
      {renderPopup()}
      <Retry isLoading={loading} showError={isError} isEmpty={isEmpty} fetchData={retryHandler}>
        <React.Fragment key="cards">
          {METRIC_ARR.map((metric) => (
            <MetricCard
              key={metric.name}
              metric={metric.name}
              chartData={chartData[metric.name]}
              selected={isSelectedMetric(metric.name)}
            />
          ))}
        </React.Fragment>
      </Retry>
    </ContentWrapper>
  );
}

export default Content;
